// Import Swiper and modules
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Initialize opinions slider when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
  // Check if there's a opinions swiper on the page
  const opinionsSwiper = document.querySelector('.opinions__swiper');

  if (opinionsSwiper) {
    const swiper = new Swiper('.opinions__swiper', {
      modules: [Navigation, Pagination, Autoplay],

      // Navigation arrows
      navigation: {
        nextEl: '.opinions__nav--next',
        prevEl: '.opinions__nav--prev',
      },

      // Pagination dots
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      // Autoplay
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      loop: opinionsSwiper.querySelectorAll('.swiper-slide').length > 1,
    });
  }
});
